import React from 'react';
import { connect } from 'react-redux';
import { MenuItemLink, getResources, Responsive, translate } from 'react-admin';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import DashboardIcon from '../icon/IcnDashboard';
import DefaultIcon from '@material-ui/icons/ViewList';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    icon: { marginLeft: '0.5em', marginRight: '0.5em' },
};

const MyMenu = ({ resources, onMenuClick, logout, translate, classes}) => (
    <div >
        <MenuItemLink
            onClick={onMenuClick}
            to="/"
            primaryText={translate('ra.page.dashboard')}
            leftIcon={<DashboardIcon />}
            classes={classes}/>
        {
            resources
            .filter(r => r.hasList && r.name !== "reports")
            .map(
                resource => (
                    <MenuItemLink 
                        key={resource.name} 
                        to={`/${resource.name}`} 
                        leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                        primaryText={translate(`resources.${resource.name}.name`)}
                        onClick={onMenuClick}
                        classes={classes}/>
                )   
            )
        }
        <Responsive
            medium={null} // Pass null to render nothing on larger devices
        />
    </div>
);

const mapStateToProps = state => ({
    resources: getResources(state),
});

const enhance = compose(
    withStyles(styles),
    translate,
    connect(mapStateToProps),
    withRouter
);

export default enhance(MyMenu);